export default __webpack_public_path__ + "static/media/keyvisual-hegau-bodensee.7a483688.jpeg";